import React from "react";
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface FAQItem {
  question: string;
  answer: string;
  code: string;
}

const faqData: FAQItem[] = [
  {
    question: "How do I activate a new SIM?",
    answer:
      "Dial the code below to activate your new SIM, or go to the My eSIMs page and select the number you want to activate.",
    code: "*121#",
  },
  {
    question: "How can I check my main balance?",
    answer: "Dial the following code to check your main balance.",
    code: "*122#",
  },

  {
    question: "How can I check my data usage?",
    answer: "Dial this code to see your remaining data usage.",
    code: "*123#",
  },
];

const FaQPage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box py={6}>
        {/* Header */}
        <Stack spacing={1} mb={4}>
          <Typography variant="h4" fontWeight={700}>
            Frequently Asked Questions
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Quick help for common services and USSD codes
          </Typography>
        </Stack>

        {/* FAQ List */}
        <Stack spacing={2}>
          {faqData.map((item, index) => (
            <Accordion
              key={index}
              disableGutters
              sx={{
                borderRadius: 2,
                "&:before": { display: "none" },
                boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontWeight={600}>{item.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={1}>
                  <Typography color="text.secondary">{item.answer}</Typography>
                  <Typography
                    fontWeight={700}
                    sx={{
                      bgcolor: "grey.100",
                      px: 2,
                      py: 1,
                      borderRadius: 1,
                      width: "fit-content",
                    }}
                  >
                    {item.code}
                  </Typography>
                </Stack>
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>
      </Box>
    </Container>
  );
};

export default FaQPage;
